import { render, staticRenderFns } from "./BuilderTopbar.vue?vue&type=template&id=501fc28c&scoped=true&"
import script from "./BuilderTopbar.vue?vue&type=script&lang=js&"
export * from "./BuilderTopbar.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTopbar.vue?vue&type=style&index=0&id=501fc28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fc28c",
  null
  
)

export default component.exports